/**
 * Update settings
 *
 * @description
 * This script is intendet to only update the one entry in the setttings store
 * with whatever info comes along due to another update of the store.
 *
 * If a new object store is added and it has the nature of a list (e.g.
 * "notes"), it most definately will need a pagination option, e.g. "max items
 * per page. Since the user should be able to manage such festures, they must
 * be written to the "settings" store (and NOT to the store that was just
 * added).
 *
 * Since the global database object "GeoMoverDB" is not available in the update
 * scripts and therefore no access is given to the "updateOneSetting" method,
 * we need to externalise that very method and import it into the update
 * scripts separately.
 *
 * Since at this point a transaction (the update) is already running, we need
 * to send over that very running transaction - NOT the database!!!
 */

/* eslint-disable no-console */

const updateOneSettingsAfterUpdate = (tx, obj, version) => {
  const settingsStore = tx.objectStore('settings')
  const cursorRequest = settingsStore.openCursor()

  cursorRequest.onsuccess = e => {
    const cursor = e.target.result

    try {
      const itemToUpdate = cursor.value
      // console.log('GEOMOVERDB::updateOneSetting:cursorRequest itemToUpdate =', itemToUpdate)
      itemToUpdate[obj.feature] = obj.value
      itemToUpdate.lastUpdated = Date.now()

      const updateRequest = cursor.update(itemToUpdate)

      updateRequest.onsuccess = e => {
        return tx.complete
      }

      updateRequest.onerror = e => {
        console.log('Update "Settings Store After Update" error happened: e =', e.id + ': ' + e.message)
        return new Error(e)
      }
    }
    catch (error) {
      console.log('updateOneSettingAfterUpdate: cursor could not be created, error =', error)
      return error
    }
    finally {
      console.log('updateOneSettingAfterUpdate: finally done')
    }
  }

  cursorRequest.onError = e => {
    console.log('cursorRequest error =', e.id + ': ' + e.message)
  }
}

export default updateOneSettingsAfterUpdate
